import * as React from "react";
import { HTMLProps, useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
`;

const BGImage = styled.img`
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
`;

const FGImage = styled(BGImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

interface Props {
  sources: Array<HTMLProps<HTMLImageElement>["src"]>;
  alt: HTMLProps<HTMLImageElement>["alt"];
}

export const ParallaxMouse = ({ sources, alt }: Props) => {
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const containerRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const { current } = containerRef;
    if (!current) {
      throw new Error("DOM is not mounted");
    }
    const containerRect = current.getBoundingClientRect();
    const containerCenterX = containerRect.x + containerRect.width / 2;
    const containerCenterY = containerRect.y + containerRect.height / 2;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const onMouseMove = ({ x, y }: MouseEvent) => {
      const offsetXinPX = x - containerCenterX;
      const offsetYinPX = y - containerCenterY;

      setOffsetX(offsetXinPX / screenWidth);
      setOffsetY(offsetYinPX / screenHeight);
    };

    document.addEventListener("mousemove", onMouseMove);
    return () => {
      document.removeEventListener("mousemove", onMouseMove);
    };
  }, [containerRef]);

  const movingImageStyle = { transform: `translate(${offsetX}%, ${offsetY}%)` };

  return (
    <Container ref={containerRef}>
      {sources.map((src, i) =>
        i === 0 ? (
          <BGImage key={i} src={src} alt={alt} />
        ) : (
          <FGImage
            key={i}
            style={i === 1 ? movingImageStyle : {}}
            src={src}
            alt=""
          />
        )
      )}
    </Container>
  );
};
